<template>
    <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto p-6">
       

        <template v-if="vg_selectedLocation.id">
            <div class="text-center">
                <block-loading/>
            </div>
            <p class="py-4 -mt-24 text-center">Please wait, while we are processing...</p>
        </template>

        <div v-else class="flex lg:flex-row  items-center justify-center flex-col bg-[#2B2C32] rounded-xl">
            
            <div class="w-full">
              <div class="bg-[#2B2C32] rounded-lg px-8 py-[16px]">
                <p  class="text-center text-theme-red">Please select a location from the top left corner.</p>
              </div>
            </div>
          
        </div>
    </div>
</template>

<script lang="ts">
import { useRoute, useRouter } from 'vue-router'
import  { defineComponent , ref} from "vue";
import { mapGetters, mapActions, mapMutations } from "vuex";
import { useSnackbar } from "vue3-snackbar";

export default defineComponent({
  name: "CloverResponse",
  components: {

  },

  setup() {
    const router = useRouter()
    const route = useRoute()
    
    return {
      router,
      route,
    }
  },

  computed: {
    ...mapGetters({
      vg_selectedLocation: 'location/selected'
    }),
  },

  watch: {
 
  },

  async mounted() {
    await this.vm_mutateCloverDetails({
        clover_response: this.route.query, //this.$route.query
    })
  },

  methods: {
    ...mapMutations({
      vm_mutateCloverDetails: "clover/detailsMutate",
    })
  }
});
</script>
<style>
.clover-response-wrap aside#leftNav,
.clover-response-wrap nav {
    display: none;
}
.clover-response-wrap .h-screen-appheader{
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
.clover-response-wrap .min-w-\[740px\]{
  min-width: 100%
}
</style>

